import { createApi } from "@reduxjs/toolkit/query/react";
import { tokenQuery } from "./tokenQuery";

const calculatorAPI = createApi({
    reducerPath: "calculatorAPI",
    baseQuery: tokenQuery,
    endpoints: (builder) => ({
        getVehicleCharge: builder.mutation({
            query: ({month, vehicle, staffId}) => {
                const params = {
                    'month': month,
                    'vehicleType': vehicle,
                };
                if(staffId){
                    params['staffId'] = staffId;
                }
                const queryParams = new URLSearchParams(params);

                const apiUrl = `staff/auth/get/batch?${queryParams.toString()}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        getSharedData: builder.mutation({
            query: ({staffId}) => {
                let url = 'staff/auth/get/shared/charges';
                if(staffId){
                    url += `?staffId=${staffId}`
                }

                return {
                    url,
                    method: "GET",
                };
            },
            transformResponse: (response) => {
                return Array.isArray(response) ? response : Object.values(response);
            }
        })
    }),
});

export const { 
    useGetVehicleChargeMutation,
    useGetSharedDataMutation
} = calculatorAPI;

export default calculatorAPI;